import Button from "@mui/material/Button";
import {
    Box,
    Chip, Collapse,
    styled, Typography
} from "@mui/material";
import Link from "@mui/material/Link";
import React from "react";
import {display24HourTime} from "../shared/date.js";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {RSVPButton} from "./RSVP.jsx";
import {VenueMetaAgeChip, VenueMetaCoverChip} from "./VenueMeta.jsx";
import VisibilityButton from "./Button/VisibilityButton.jsx";
import {toSlots} from "../shared/class/event.ts";
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import InstagramIcon from '@mui/icons-material/Instagram';
import TipBox from "./TipBox.jsx";
import PopularButton from "./Button/PopularButton.jsx";
import EventPopular from "./Icon/EventPopular.jsx";
import SpecialButton from "./Button/SpecialButton.jsx";

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <ExpandMoreIcon {...other} />;
})(({ theme }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
    variants: [
        {
            props: ({ expand }) => !expand,
            style: {
                transform: 'rotate(0deg)',
            },
        },
        {
            props: ({ expand }) => !!expand,
            style: {
                transform: 'rotate(180deg)',
            },
        },
    ],
}));

export const EventCardCompact = (props) => {
   
    const {venue, date, special, event_artists = [], event_instructors = [], title, ticketUrl, instagramUrl} = props.event;

    // Combine and sort by time
    const slots = toSlots(event_artists, event_instructors);

    //const href = `https://austin2step.com/event/${venue.venueKey}/${date}`
    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

  
    return <Box>
            {/*<Button onClick={e => copyToClipboard(e, href, user)} href={href} size={"small"} style={{float: "right", margin: "20px"}} variant="contained" endIcon={<IosShareIcon />}>Share</Button>*/}
        {special && <Box style={{display: "flex", justifyContent: "center", backgroundColor: "red", padding: "5px", borderRadius: "5px", marginBottom: "10px"}}><Typography variant={"h6"} style={{color: "white"}}>Special Event</Typography></Box>}
        <div style={{float: "right"}}>
            <RSVPButton date={date} venueKey={venue.venueKey} style={{float: "right"}}/>
        </div>
        <Box>
            <span style={{fontSize: "125%"}}>{venue.name}</span>
            <PopularButton event={props.event} />
            <EventPopular event={props.event} />
            <SpecialButton event={props.event} />
        </Box>
        <Box mb={1} style={{position: "relative", top: "-6px"}}>
            <span style={{textTransform: "uppercase", fontFamily: "arial", fontSize:"70%"}}>{venue.location}</span>
        </Box>
        {title && <Box>
            <Typography variant={"h6"} style={{fontWeight: "bold"}}>{title}</Typography>
        </Box>}
        {ticketUrl && <Box>
            <Button size={"small"} startIcon={<BookOnlineIcon />} href={ticketUrl} target={"_blank"}>Tickets</Button>
        </Box>}
        {instagramUrl && <Box>
            <Button size={"small"} startIcon={<InstagramIcon />} href={instagramUrl} target={"_blank"}>Instagram</Button>
        </Box>}
        <Box mt={1}>
            <table>
                <tbody>
                    {slots.map((slot, i) => <tr key={i}>
                        <td style={{ textAlign: "right", verticalAlign:"top", padding: "0 6px 0 0"}}>{display24HourTime(slot.time)}</td>
                        <td style={{ padding: 0}}>{slot?.artist?.danceable ?
                            <Link href={"/artist/" + slot?.artist?.artistKey}><strong>{slot.title}</strong></Link>
                            : slot.title}
                            {slot?.artist?.tag && <Chip size={"small"} style={{marginLeft: "8px"}} label={slot?.artist?.tag} />}
                            {slot?.artist?.venmo && <TipBox artist={slot.artist} />}
                             <VisibilityButton slot={slot}/>
                        </td>
                    </tr>)}
            
                </tbody>
            </table>
        </Box>
        <Box sx={{display: "flex", justifyContent: "center"}}>
            <Button
                size={"small"}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
                endIcon={<ExpandMore expand={expanded} />}>
                {expanded ? "Hide" : "More"}
            </Button>
        </Box>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box m={2} py={2}>
                <Box>
                    <VenueMetaCoverChip venue={venue} />
                    <VenueMetaAgeChip venue={venue} />
                </Box>
                {venue.daysToVisit &&<Box mt={2}>
                    <Typography variant={"body2"}>
                        Best days: {venue.daysToVisit}
                    </Typography>
                </Box>}
                {venue.whatToExpect &&<Box mt={2}>
                    <Typography variant={"body2"} style={{whiteSpace: "pre-line"}}>
                        {venue.whatToExpect}
                    </Typography>
                </Box>}
                <Box mt={2}>
                    <Typography variant={"body2"}>
                        <Link href={"/venue/" + venue.venueKey}>Click Here</Link> for {venue.name} specific calendar, address, socials and directions.
                    </Typography>
                </Box>
            </Box>
        </Collapse>
    </Box>
}